import { render } from "./sidebar.vue?vue&type=template&id=c295e984&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=c295e984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c295e984"]])

export default __exports__